module.exports = __webpack_public_path__ + "static/media/icon-enb.a4e0e46d.svg";